import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddCouponPage = React.lazy(() => import(/* webpackChunkName: "AdminAddCoupon" */ './Page'));
export const AdminAddCoupon = () => (React.createElement(Page, { title: "Administrator Add Coupon" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddCouponPage, null)))));
